import React from 'react';
import {
  msgAvatar,
  blueMoonAvatar,
  lvlBeginner,
  lvlIntermediate,
  lvlAdvanced,
  lvlExpert,
  lvlExpertPlus,
  lvlMaster
} from '../../assets/images/index';
import './user-avatar.scss';

interface UserAvatarProps {
  levelKey: string;
  levelIcon?: string;
  userImage?: string | null;
}

/**
 * Mapping of level keys or icon names to specific foreground images.
 */
const LEVEL_IMAGES: Record<string, string | null> = {
  // DB Icon Keys
  'lvl_beginner': lvlBeginner,
  'lvl_intermediate': lvlIntermediate,
  'lvl_advanced': lvlAdvanced,
  'lvl_expert': lvlExpert,
  'lvl_expert_plus': lvlExpertPlus,
  'lvl_master': lvlMaster,

  // Store Key Fallbacks (for instant UI response)
  'beginner': lvlBeginner,
  'intermediate': lvlIntermediate,
  'advanced': lvlAdvanced,
  'expert': lvlExpert,
  'expert_plus': lvlExpertPlus,
  'master': lvlMaster,
};

export const UserAvatar: React.FC<UserAvatarProps> = ({ levelKey, levelIcon, userImage }) => {
  // Priority: 1. Icon name from DB, 2. Level key mapping, 3. User uploaded avatar
  const foregroundImage = (levelIcon && LEVEL_IMAGES[levelIcon]) || LEVEL_IMAGES[levelKey] || userImage;

  return (
    <div className="user-avatar-wrapper">
      {/* The overlay image (Level character or User profile) */}
      {foregroundImage && (
        <div className="avatar-foreground-container">
          <img
            src={foregroundImage}
            alt="avatar-character"
            className="avatar-foreground"
          />
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
